import i18next, { ExistsFunction, i18n, TFunction } from 'i18next';
import i18nBackend from 'i18next-http-backend';
import { App } from 'vue';
import { AppConfig } from '@dh-io-emh/config-types';
import { getStorageItem, setStorageItem } from '../utils/persistence.util';

let i18nextInstance: i18n;

export type I18nService = { t: TFunction; exists: ExistsFunction };

export const addResources = (resources: Record<string, any>, locale: string = i18nextInstance?.language) => {
  if (i18nextInstance) {
    i18nextInstance.addResourceBundle(locale, i18nextInstance?.options.ns?.[0] ?? 'translation', resources, true, true);
  }
};

export const toggleTranslationKeys = () => {
  const cimode = getStorageItem<string>('cimode') ? undefined : 'cimode';

  setStorageItem('cimode', cimode);
  console.log(`${cimode ? 'cimode is active' : 'translation keys restored'}, refresh the page to see the changes`);
};

export async function createI18nService({ availableLanguages, locale, translationApi }: AppConfig, app: App) {
  i18nextInstance = i18next.createInstance();

  const t = i18nextInstance.t.bind(i18nextInstance);
  const exists = i18nextInstance.exists.bind(i18nextInstance);

  if (app) app.config.globalProperties.$t = t;

  (window as any).toggleTranslationKeys = toggleTranslationKeys;

  await i18nextInstance.use(i18nBackend).init({
    backend: {
      loadPath: translationApi,
      parse: (data: string) => JSON.parse(data),
    },
    lng: getStorageItem<string>('cimode') ?? locale,
    returnEmptyString: false,
    parseMissingKeyHandler: (key) => key, // Return the key of missing translations
    supportedLngs: availableLanguages as any,
    debug: false,
  });

  return { t, exists };
}
